import React, { Component } from "react";
import Dot from "./dot";
import "./dots.css";

export default class Dots extends Component {
  static defaultProps = {
    onChange: () => { },
    className: "",
    arrow: false
  };

  constructor(props) {
    super(props);
    this.state = {
      activeIndex: 0
    };
  }

  componentDidUpdate(prevProps) {
    if (prevProps.activeIndex !== this.props.activeIndex) {
      this.setState({
        activeIndex: this.props.activeIndex
      });
    }
  }

  onClickDot(index) {
    const { onChange } = this.props;
    this.setState(
      {
        activeIndex: index
      },
      () => {
        onChange(index);
      }
    );
  }

  onClickArrow(index, limit, forward) {
    const { onChange } = this.props;
    if (forward) index = index + 1 > limit - 1 ? 0 : index + 1
    else {
      index = index - 1 < 0 ? limit - 1 : index - 1
    }

    this.setState(
      {
        activeIndex: index
      },
      () => {
        onChange(index)
      }
    )
  }

  render() {
    const { isArrow, items, className } = this.props;
    const { activeIndex } = this.state;
    return (
      <div>
        {isArrow ?
          <div className={`d-flex ${className} isArrow`}>
            <button onClick={this.onClickArrow.bind(this, activeIndex, items.length, false)} className="isVisibleArrow">
              <img
                alt="backArrow"
                src={require("images/icons/leftArrow.svg")}
                className="arrowBttn"
              />
            </button>
            <div className='js-dots'>
              {items.map((item, index) => (
                <Dot
                  key={Math.random().toString(36).substring(2, 15)}
                  onClick={this.onClickDot.bind(this, index)}
                  selected={activeIndex === index}
                />
              ))}
            </div>
            <button onClick={this.onClickArrow.bind(this, activeIndex, items.length, true)} className="isVisibleArrow">
              <img
                alt="forwardArrow"
                src={require("images/icons/rightArrow.svg")}
                className="arrowBttn"
              />
            </button>
          </div>
          :
          <div className={`d-flex js-dots ${className}`}>
            {items.map((item, index) => (
              <Dot
                key={Math.random().toString(36).substring(2, 15)}
                onClick={this.onClickDot.bind(this, index)}
                selected={activeIndex === index}
              />
            ))}
          </div>

        }
      </div>
    );
  }
}
